import { FilterGradeLevel, BlockType, AllScience35Blocks, FullScience35Blocks } from "shared/types/science35Types"

export function teacherScienceGradeLevels(blockType: BlockType, scienceBlocks: BlockType[]): FilterGradeLevel[] {
    if (!AllScience35Blocks.includes(blockType)) return []

    const hasFullScience35License = scienceBlocks.some(b => FullScience35Blocks.includes(b))
    
    return [
        { grade: "3rd Grade", isValid: scienceBlocks.includes("Science 35 NY Grade 3") || scienceBlocks.includes("Science 35 National Grade 3") || hasFullScience35License },
        { grade: "4th Grade", isValid: scienceBlocks.includes("Science 35 NY Grade 4") || scienceBlocks.includes("Science 35 National Grade 4") || hasFullScience35License },
        { grade: "5th Grade", isValid: scienceBlocks.includes("Science 35 NY Grade 5") || scienceBlocks.includes("Science 35 National Grade 5") || hasFullScience35License },
    ] as FilterGradeLevel[]
}